export const classes = {
  horizontal: 'flex flex-wrap items-baseline gap-x-2',
  title: 'mb-0 font-semibold',
  subtitle: 'text-sm text-grey-7 dark:text-mauve-2',
};
